import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { MonitoringService } from '@core/services/monitoring.service';

@Injectable({
  providedIn: 'root'
})
export class TraceHttpInterceptor implements HttpInterceptor {
  constructor(private monitoringService: MonitoringService) {}

  requestCounter = 0;

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.monitoringService.logTrace(
      `[HTTP] ${req.method} ${req.urlWithParams}`,
      {
        request: req
      }
    );
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        const reason =
          err && err.error && err.error.reason ? err.error.reason : '';
        this.monitoringService.logException(err, undefined, {
          request: req,
          status: err.status,
          reason: reason,
          response: {
            url: err.url,
            headers: err.headers,
            message: err.message
          }
        });
        return throwError(err);
      })
    );
  }
}
